<template>
  <v-container>
    <gridView v-if="edit" @editItem="editItem" />
    <formView v-else :collection="collection" :from="from" @editItem="editItem" />
  </v-container>
</template>

<script>
import gridView from './grid'
import formView from './form'

export default {
  name: 'credential',

  data: () => ({
    edit: true,
    collection: '',
    from: ''
  }),

  components: {
    gridView,
    formView
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.collection = item?.collection
      this.from = item?.from
    }
  }
}
</script>
